import { useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';

import { useCreateEdgeLocationDrawer } from './useCreateEdgeLocationDrawer';
import {
  edgeLocationDrawerKey,
  edgeLocationProviderKey,
  edgeLocationProviderProjectIdKey,
  edgeLocationRegionKey,
} from '../constants';

import { useCluster } from '@cast/shared-cluster-context-data-access';

export const useNavigateToEdgeLocationDrawer = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const { cluster } = useCluster();
  const { openCreateEdgeLocationDrawer } = useCreateEdgeLocationDrawer();

  useEffect(() => {
    const edgeLocationKeyParam = searchParams.get(edgeLocationDrawerKey);
    const providerParam = searchParams.get(edgeLocationProviderKey);
    const regionParam = searchParams.get(edgeLocationRegionKey);
    const providerProjectIdParam = searchParams.get(
      edgeLocationProviderProjectIdKey
    );

    if (edgeLocationKeyParam) {
      const hasInitialData =
        providerParam || regionParam || providerProjectIdParam;

      openCreateEdgeLocationDrawer({
        clusterId: cluster.id,
        initialData: hasInitialData
          ? {
              provider: providerParam || undefined,
              region: regionParam || undefined,
              providerProjectId: providerProjectIdParam || undefined,
            }
          : undefined,
      });

      setSearchParams((prev) => {
        const newParams = new URLSearchParams(prev);
        newParams.delete(edgeLocationDrawerKey);
        newParams.delete(edgeLocationProviderKey);
        newParams.delete(edgeLocationRegionKey);
        newParams.delete(edgeLocationProviderProjectIdKey);

        return newParams;
      });
    }
  }, [cluster, openCreateEdgeLocationDrawer, searchParams, setSearchParams]);
};
